import SnackbarContent from '@mui/material/SnackbarContent';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';

export default function CustomSnackbar({ text, onClose, open, Icon }) {
    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <SnackbarContent
                style={{
                    borderRadius: 16,
                }}
                message={
                    <>
                        <Stack direction={'row'} alignItems={'center'}>
                            {Icon !== undefined && <Icon />}
                            <span style={{ marginLeft: 16 }}>{text}</span>
                        </Stack>
                    </>
                }
            />
        </Snackbar>
    );
}
